import React, { useState } from "react";
import { Map } from "immutable";
import { PropTypes } from "prop-types";
import T from "./t.jsx";
import { displayErrors } from "./validation.jsx";
import Modal from "react-responsive-modal";
import SignaturePad from "react-signature-pad-wrapper";

export class Sign extends React.Component {
  constructor(props) {
    super(props);
    this.signaturePadRef = React.createRef();
    this.signaturePadInsideModalRef = React.createRef();
    this.state = {
      open: false,
      signaturePad: null,
    };
  }

  resetInput = (isModal) => {
    if (isModal) {
      this.signaturePadInsideModalRef.current.instance.clear();
    } else {
      this.signaturePadRef.current.instance.clear();
    }
    this.props.onInput(
      Map({
        name: "",
        dirty: true,
        errors: this.defaultError(),
        image: "",
        lines: [],
      })
    );
  };

  defaultError = () => {
    return ["identification-required"];
  };
  handleChange = (event) => {
    let text = event.target.value.substr(0, 255);
    this.props.onInput(
      this.props.data
        .set("name", text)
        .set(
          "errors",
          this.props.data.get("lines", []).length > 0
            ? this.validateName(text)
            : this.defaultError()
        )
    );
  };

  validateName = (text) => {
    if (this.props.name) {
      return text.trim().length === 0 ? this.defaultError() : [];
    } else {
      return [];
    }
  };
  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onDone = () => {
    let ratio =
      this.signaturePadRef.current.canvasRef.current.offsetWidth /
      this.signaturePadInsideModalRef.current.canvasRef.current.offsetWidth;
    let data = this.signaturePadInsideModalRef.current.instance.toData();
    data = data.map((item) => {
      return {
        ...item,
        points: item.points.map((point) => {
          return {
            ...point,
            x: point.x * ratio,
            y: point.y * ratio,
            presure: point.presure * ratio,
          };
        }),
      };
    });

    this.signaturePadRef.current.instance.fromData(data);
    this.setState(
      {
        signaturePad: this.signaturePadRef.current,
      },
      () => {
        this.onStrokeEnd();
      }
    );
    this.onCloseModal();
  };

  onStrokeEnd = () => {
    this.props.onInput(
      Map({
        name: this.props.data.get("name", ""),
        dirty: true,
        errors: this.validateName(this.props.data.get("name", "")),
        image: this.state.signaturePad.instance.toDataURL(),
        lines: this.state.signaturePad.instance.toData() || [],
      })
    );
  };

  componentDidMount() {
    this.setState(
      {
        signaturePad: this.signaturePadRef.current,
      },
      () => {
        if (this.state.signaturePad) {
          this.state.signaturePad.instance.addEventListener(
            "endStroke",
            this.onStrokeEnd
          );
        }
      }
    );
  }

  onEntered = () => {
    const signaturePad = this.signaturePadRef.current;
    let ratio = this.signaturePadInsideModalRef.current.canvasRef.current.offsetWidth / this.signaturePadRef.current.canvasRef.current.offsetWidth;
    let data = signaturePad.instance.toData();
    data = data.map((item) => {
      return {
        ...item,
        points: item.points.map((point) => {
          return {
            ...point,
            x: point.x * ratio,
            y: point.y * ratio,
            presure: point.presure * ratio,
          };
        }),
      };
    });

    this.signaturePadInsideModalRef.current.instance.fromData(data);
  };

  render() {
    return (
      <div className="validation__signature-block row--large">
        {this.props.customTitle ? (
          <h4 className="question__title required">{this.props.customTitle}</h4>
        ) : (
          <T className="question__title required" component="h4">
            signature
          </T>
        )}

        <T className="question__description" component="p">
          signature-description
        </T>

        <div className="validation__signature row--small">
          <SignaturePad ref={this.signaturePadRef} />
          <div className="question__sign-separator" />
        </div>

        {this.props.name ? (
          <div className="row--small">
            <input
              className="validation__signature-name"
              type="text"
              value={this.props.data.get("name", "")}
              onChange={this.handleChange}
              placeholder={this.context.translate.translate(
                "signature-placeholder"
              )}
            />
          </div>
        ) : null}

        {displayErrors(this.props.data)}
        <div>
          <button
            type="button"
            className="button print-hide"
            onClick={this.resetInput.bind(this, false)}
          >
            <i className="fa fa-square-o" />
            <T>reset</T>
          </button>
          <button
            onClick={() => {
              this.onOpenModal();
            }}
            type="button"
            className="button print-hide"
          >
            <img
              alt=""
              style={{ width: "14px", marginRight: "5px" }}
              src="data:image/png;base64,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"
            />
            <T>signature</T>
          </button>
        </div>
        <div>
          <Modal
            open={this.state.open}
            onClose={() => {
              this.onCloseModal();
            }}
            onEntered={() => {
              this.onEntered();
            }}
            little
          >
            <T
              className="question__title required"
              style={{ marginRight: "3em" }}
              component="h2"
            >
              signature
            </T>
            <div
              className="validation__signature row--small"
              style={{ width: "100%" }}
            >
              <SignaturePad ref={this.signaturePadInsideModalRef} />
              <div className="question__sign-separator" />
            </div>
            {this.props.name ? (
              <div className="row--small">
                <input
                  className="validation__signature-name"
                  type="text"
                  value={this.props.data.get("name", "")}
                  onChange={this.handleChange}
                  placeholder={this.context.translate.translate(
                    "signature-placeholder"
                  )}
                />
              </div>
            ) : null}
            {displayErrors(this.props.data)}
            <div className="row--small">
              <button
                type="button"
                className="button print-hide"
                onClick={this.resetInput.bind(this, true)}
              >
                <i className="fa fa-square-o" />
                <T>reset</T>
              </button>
              <button
                type="button"
                className="button print-hide"
                onClick={() => {
                  this.onCloseModal();
                  this.resetInput(true);
                }}
              >
                <T>cancel</T>
              </button>
              <button
                type="button"
                className="button button--positive print-hide"
                disabled={
                  this.props.name && this.props.data.get("name", "") === ""
                }
                onClick={() => {
                  this.onDone();
                }}
              >
                <T>done</T>
              </button>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

Sign.propTypes = {
  onInput: PropTypes.func.isRequired,
  data: PropTypes.object,
  name: PropTypes.bool,
};

Sign.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired,
    addListener: PropTypes.func,
    removeListener: PropTypes.func,
  }).isRequired,
};

export class SecondarySign extends Sign {
  render() {
    return (
      <div className="validation__signature-block row--large">
        {this.props.customTitle ? (
          <h4 className="question__title">{this.props.customTitle}</h4>
        ) : (
          <T className="question__title" component="h4">
            secondary-signature
          </T>
        )}

        <T className="question__description" component="p">
          secondary-signature-description
        </T>

        <div className="validation__signature row--small">
          <SignaturePad ref={this.signaturePadRef} />
          <div className="question__sign-separator" />
        </div>

        <div className="row--small">
          <input
            className="validation__signature-name row--large"
            type="text"
            value={this.props.data.get("name", "")}
            onChange={this.handleChange}
            placeholder={this.context.translate.translate(
              "secondary-signature-placeholder"
            )}
          />
        </div>
        {displayErrors(this.props.data)}
        <div>
          <button
            type="button"
            className="button print-hide"
            onClick={this.resetInput.bind(this, false)}
          >
            <i className="fa fa-square-o" />
            <T>reset</T>
          </button>
          <button
            onClick={() => {
              this.onOpenModal();
            }}
            type="button"
            className="button print-hide"
          >
            <img
              alt=""
              style={{ width: "14px", marginRight: "5px" }}
              src="data:image/png;base64,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"
            />
            <T>signature</T>
          </button>
        </div>

        <div>
          <Modal
            open={this.state.open}
            onClose={() => {
              this.onCloseModal();
            }}
            onEntered={() => {
              this.onEntered();
            }}
            little
          >
            <T
              className="question__title required"
              style={{ marginRight: "3em" }}
              component="h2"
            >
              signature
            </T>
            <div
              className="validation__signature row--small"
              style={{ width: "100%" }}
            >
              <SignaturePad ref={this.signaturePadInsideModalRef} />
              <div className="question__sign-separator" />
            </div>
            {this.props.name ? (
              <div className="row--small">
                <input
                  className="validation__signature-name"
                  type="text"
                  value={this.props.data.get("name", "")}
                  onChange={this.handleChange}
                  placeholder={this.context.translate.translate(
                    "signature-placeholder"
                  )}
                />
              </div>
            ) : null}
            {displayErrors(this.props.data)}
            <div className="row--small">
              <button
                type="button"
                className="button print-hide"
                onClick={this.resetInput.bind(this, true)}
              >
                <i className="fa fa-square-o" />
                <T>reset</T>
              </button>
              <button
                type="button"
                className="button print-hide"
                onClick={() => {
                  this.onCloseModal();
                  this.resetInput(true);
                }}
              >
                <T>cancel</T>
              </button>
              <button
                type="button"
                className="button button--positive print-hide"
                disabled={
                  this.props.name && this.props.data.get("name", "") === ""
                }
                onClick={() => {
                  this.onDone();
                }}
              >
                <T>done</T>
              </button>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

SecondarySign.propTypes = {
  onInput: PropTypes.func.isRequired,
  data: PropTypes.object,
  name: PropTypes.bool,
};

SecondarySign.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired,
    addListener: PropTypes.func,
    removeListener: PropTypes.func,
  }).isRequired,
};
